"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/bnpl-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fbnpl-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.BnplTestApiServiceClient = exports.SetEligibilityResponse = exports.SetEligibilityRequest = exports.DisableBnplResponse = exports.DisableBnplRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const bnpl_testing_service_1 = require("../bnpl/testing/bnpl-testing-service");
const lending_eligibility_1 = require("../common/lending-eligibility");
const protobufPackage = 'com.step.testapi.bnpl.proto';
function createBaseDisableBnplRequest() {
    return { userId: '' };
}
exports.DisableBnplRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.DisableBnplRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisableBnplRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseDisableBnplResponse() {
    return {};
}
exports.DisableBnplResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DisableBnplResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDisableBnplResponse();
        return message;
    },
};
function createBaseSetEligibilityRequest() {
    return { userId: '', eligibility: lending_eligibility_1.LendingEligibility.fromPartial({}) };
}
exports.SetEligibilityRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            eligibility: isSet(object.eligibility)
                ? lending_eligibility_1.LendingEligibility.fromJSON(object.eligibility)
                : lending_eligibility_1.LendingEligibility.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.eligibility !== undefined) {
            obj.eligibility = lending_eligibility_1.LendingEligibility.toJSON(message.eligibility);
        }
        return obj;
    },
    create(base) {
        return exports.SetEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetEligibilityRequest();
        message.userId = object.userId ?? '';
        message.eligibility = (object.eligibility !== undefined && object.eligibility !== null)
            ? lending_eligibility_1.LendingEligibility.fromPartial(object.eligibility)
            : lending_eligibility_1.LendingEligibility.fromPartial({});
        return message;
    },
};
function createBaseSetEligibilityResponse() {
    return {};
}
exports.SetEligibilityResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetEligibilityResponse();
        return message;
    },
};
/**
 * BNPL Test API Service
 */
class BnplTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.bnpl.proto.BnplTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'DisableBnpl',
            requestType: exports.DisableBnplRequest,
            responseType: exports.DisableBnplResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetEligibility',
            requestType: exports.SetEligibilityRequest,
            responseType: exports.SetEligibilityResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetDueAt',
            requestType: bnpl_testing_service_1.SetDueAtRequest,
            responseType: bnpl_testing_service_1.SetDueAtResponse,
            authenticationOptions: undefined,
        }, {
            name: 'ProcessInstallment',
            requestType: bnpl_testing_service_1.ProcessInstallmentRequest,
            responseType: bnpl_testing_service_1.ProcessInstallmentResponse,
            authenticationOptions: undefined,
        }, {
            name: 'UpdateTestUser',
            requestType: bnpl_testing_service_1.UpdateTestUserRequest,
            responseType: bnpl_testing_service_1.UpdateTestUserResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetTestUser',
            requestType: bnpl_testing_service_1.GetTestUserRequest,
            responseType: bnpl_testing_service_1.GetTestUserResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Disables BNPL for a user.
     */
    disableBnpl(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets BNPL eligibility.
     */
    setEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets the due_at timestamp for the given installment.
     */
    setDueAt(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Immediately runs any processing jobs that are due to be run for the given
     * installment.
     */
    processInstallment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update test BNPL user.
     */
    updateTestUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get test BNPL user.
     */
    getTestUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.BnplTestApiServiceClient = BnplTestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=bnpl-testapi-service.js.map